import React, { useContext } from "react";
import { SelectedCardContext } from "../../Context/SelectedCardContext";
import styles from "../About/About.module.css";
import arrowleft from "../../Assests/icons/leftArrow.svg";
import arrowright from "../../Assests/icons/rightArrow.svg";
import Carousel from "react-multi-carousel";
import "react-multi-carousel/lib/styles.css";

const responsive = {
  superLargeDesktop: {
    breakpoint: { max: 4000, min: 1280 },
    items: 3,
  },
  desktop: {
    breakpoint: { max: 1280, min: 1024 },
    items: 3,
  },
  tablet: {
    breakpoint: { max: 1024, min: 640 },
    items: 2,
  },
  mobile: {
    breakpoint: { max: 640, min: 0 },
    items: 1,
  },
};

const arrowStyle = {
  background: "transparent",
  border: 0,
  color: "#000",
  fontSize: "80px",
};

const CustomRight = ({ onClick }) => (
  <button className={styles.arrowright} onClick={onClick} style={arrowStyle}>
    <img src={arrowright} alt="next" style={{ width: 18 }} />
  </button>
);

const CustomLeft = ({ onClick }) => (
  <button className={styles.arrowleft} onClick={onClick} style={arrowStyle}>
    <img src={arrowleft} alt="previous" style={{ width: 18 }} />
  </button>
);

const ProcurementOptions = ({ otherProcurementOptions }) => {
  const { setSelectedCard } = useContext(SelectedCardContext);

  const handleCardClick = (item) => {
    setSelectedCard(item);
    window.scrollTo({ top: 0, behavior: "smooth" }); 
  };

  return (
    <div className={styles.industryExpertiseSection}>
      <section className={styles.expertiseSection}>
        <div className={styles.expertiseHeader}>
          <div className={styles.expertiseHeading}>Related Procurement Services</div>
          {/* <div className={styles.expertiseDetailData}>
            Discover our other procurement and logistics solutions to optimize your supply chain operations.
          </div> */}
        </div>

        <Carousel
          responsive={responsive}
          swipeable
          draggable
          infinite
          keyBoardControl
          stagePadding={{ left: 5, right: 5 }}
          className={styles.expertiseCarouselList1}
          arrows
          partialVisible={false}
          itemClass={styles.expertiseCarouselItem}
          customRightArrow={<CustomRight />}
          customLeftArrow={<CustomLeft />}
        >
          {otherProcurementOptions.map((item, index) => (
            <div key={index} className={styles.expertiseItem}>
              <img src={item.image} alt={item.title} className={styles.expertiseImage} />
              <div className={styles.expertiseTextContent}>
                <h3 style={{height:"50px"}} className={styles.expertiseTitle}>{item.title}</h3>
                {/* <p className={styles.expertiseDescription}>
                  {item.description}
                </p> */}
                <button 
                  className={styles.readMoreButton} 
                  onClick={() => handleCardClick(item)}
                >
                  Read More
                </button>
              </div>
            </div>
          ))}
        </Carousel>
      </section>
    </div>
  );
};

export default ProcurementOptions;